import React from 'react';
import { motion } from 'framer-motion';
import { Container } from './ui/Container';
import { SectionTag } from './ui/SectionTag';
import { CTAButton } from './ui/CTAButton';
import { FULL_MOCKUP_URL } from '../data/images';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
export function ProductIntro() {
  return <section className="relative overflow-hidden bg-mp-black py-20 md:py-28" data-id="element-311" data-mp="1snhgi54oy0yf">
      <div className="pointer-events-none absolute left-1/2 top-0 h-[440px] w-[900px] -translate-x-1/2 opacity-40" style={{
      background: 'radial-gradient(ellipse, rgba(8,117,209,0.35), transparent 65%)'
    }} aria-hidden="true" data-id="element-312" data-mp="2ge4pktqcewmk" />
      <Container className="relative z-10 text-center" data-id="element-313" data-mp="2bm3evc8tpdyn">
        <SectionTag tone="lime" data-id="element-314" data-mp="2bkintwlpwd5j">Presentamos</SectionTag>
        <h2 className="mx-auto mt-5 max-w-[820px] font-heading text-4xl uppercase leading-tight text-mp-white sm:text-5xl md:text-6xl" data-id="element-315" data-mp="2zb5y2oj3vev9">
          Maestro en Pista
        </h2>
        <p className="mt-3 font-heading text-sm uppercase tracking-[0.15em] text-mp-electric md:text-base" data-id="element-316" data-mp="ufoooqlccggj">
          El sistema operativo del monitor de pádel
        </p>

        <div className="mx-auto mt-8 max-w-[700px] space-y-4 text-left text-base leading-relaxed text-mp-gray md:text-center md:text-lg" data-id="element-317" data-mp="pif1lhlfcgvv">
          <p data-id="element-318" data-mp="zf1la320l1wb">
            Maestro en Pista es un sistema digital de consulta, planificación y ejecución creado para ayudarte a
            transformar conocimientos dispersos en una metodología de trabajo clara.
          </p>
          <p data-id="element-319" data-mp="1861wmsy8fv5v">
            Desde cómo enseñar una doble pared hasta cómo estructurar una sesión, gestionar niveles mixtos o
            planificar la progresión de tus alumnos.
          </p>
          <p data-id="element-320" data-mp="1i4zsyi1wgszf">Todo organizado en 5 tomos que recorren las áreas fundamentales del trabajo de un monitor.</p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        ease: easeOut
      }} className="relative mx-auto mt-14 max-w-[640px]" data-id="element-321" data-mp="3owiii3bpzn42">
          <img src={FULL_MOCKUP_URL} alt="Sistema completo Maestro en Pista con los 5 tomos y bonos" width={800} height={800} loading="lazy" className="mx-auto w-full drop-shadow-2xl" data-id="element-322" data-mp="hi0ny96zwwb9" />
        </motion.div>

        <p className="mt-10 font-heading text-xs uppercase tracking-[0.18em] text-mp-gray md:text-sm" data-id="element-323" data-mp="wf1hmi8qz1cd">
          5 Tomos · 250+ Páginas · 5 Bonos · Acceso Inmediato
        </p>

        <CTAButton href="#tomos" variant="secondary" size="md" className="mt-6" fullWidthMobile={false} data-id="element-324" data-mp="156tmmdf05i9k">
          Ver todo lo que incluye ↓
        </CTAButton>
      </Container>
    </section>;
}